import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@blueprint/ui';

const CustomerLogo = () => {
    const globalState = useSelector((state) => state);
    return (
        <>
            {globalState.beneDetails.customerLogo && globalState.beneDetails.customerLogo?.size ? (
                <Box marginBottom='1em'>
                    <img src={URL.createObjectURL(globalState.beneDetails.customerLogo)} alt={globalState.beneDetails.logoAltText+' logo'} height='38px' />
                </Box>
            ) : null}
        </>
    );
};

export default CustomerLogo;
